var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"label"},[(_vm.icon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1),_c('v-divider',{staticClass:"mb-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }